import Vue from "vue";
import { mapState } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import HistoricoAtendimentoMensagens from "@/components/parent/atendimento/historicoAtendimentoMensagens/historicoAtendimentoMensagens";
import historicoAtendimentoMensagens from "@/components/parent/atendimento/historicoAtendimentoMensagens/historicoAtendimentoMensagens.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import UsuarioModel from "@/models/usuarioModel";
import AtendimentoWhatsAppModel from "@/models/whatsApp/atendimento/atendimentoWhatsAppModel";
import AtendimentoService from "@/services/atendimentos/atendimentoService";
import vendedorService from "@/services/vendedorService";
import { AppState } from "@/store/store";
import Delay from "@/utils/common/delay";

@Component({
    components: {
        comboComponent,
        dateTimePickerComponent,
        gridComponent,
        historicoAtendimentoMensagens,
        shortcutComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class BuscarAtendimentoComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    private shortCutComponent: ShortcutComponent = null;
    private historicoAtendimentoMensagens: HistoricoAtendimentoMensagens = null;

    usuariosOptions: Array<Object> = [];
    gridData: Array<AtendimentoWhatsAppModel> = [];
    extraActions: Array<object> = [];
    gridExtraActions: Array<GridAction> = [];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("nomeContato", this.$t("__.ts.nome"), GridColumnType.String),
            new GridColumn("numero", this.$t("__.ts.telefone"), GridColumnType.String),
            new GridColumn("dataUltimaMensagem", this.$t("__.ts.dataUltMsg"), GridColumnType.DateTime),
            new GridColumn("ultimaMensagem", this.$t("__.ts.ultMsg"), GridColumnType.String),
            new GridColumn("statusAtendimentoDescricao", this.$t("__.ts.statusAtend"), GridColumnType.Raw),
        ];
    }

    usuarioId = null;
    dataInicial = new Date();
    dataFinal = new Date();
    filterKey = "";

    public async open() {
        this.usuariosOptions = await vendedorService.comboCached(this.usuarioLogado.franquiaId);
        this.shortCutComponent = this.$refs.shortCutComponent as ShortcutComponent;
        this.shortCutComponent.title = this.$t("__.ts.buscarAtend") as string;
        this.shortCutComponent.show();
    }

    private async onBuscarAtendimento() {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
            const response = await new AtendimentoService().getListAtendimentosByNome(
                this.dataInicial,
                this.dataFinal,
                this.usuarioId,
                this.filterKey,
            );

            if (response.list.length == 0) {
                this.gridData = [];
                return this.$notifyError(this.$t("__.ts.nenhumAtendimentoEncontrado"));
            }

            this.gridData = response.list;

            this.gridExtraActions.splice(0);
            this.extraActions.splice(0);
            for (let i = 0; i < this.gridData.length; i++) {
                this.gridExtraActions.push(new GridAction("ver-atendimento", "Ver", "fa fa-eye", GridColors.BLUE));
            }
            this.extraActions.push(this.gridExtraActions);
        }
    }

    private async onExtraAction(name: string, model: AtendimentoWhatsAppModel) {
        if (name.trim() == "ver-atendimento") {
            while (!this.$refs.historicoAtendimentoMensagens) await Delay(5);
            this.historicoAtendimentoMensagens = this.$refs
                .historicoAtendimentoMensagens as HistoricoAtendimentoMensagens;

            this.historicoAtendimentoMensagens.show(model.id, model.nomeContato ?? model.numero);
        }
    }
}
